import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ConfigService } from 'src/app/services/config.service';
import { ProductsService } from 'src/app/services/products.service';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-modal-order-detail',
  templateUrl: './modal-order-detail.page.html',
  styleUrls: ['./modal-order-detail.page.scss'],
})
export class ModalOrderDetailPage implements OnInit {
  @Input() order;

  constructor(
    public modalController: ModalController,
    public configService: ConfigService,
    public productsService: ProductsService, 
    public analyticsService: AnalyticsService
  ) {
    this.analyticsService.AnalyticsServiceModalView('order-detail');
   }

  ngOnInit() {
  }

  //Function to close modal
  closeModal() {
    this.modalController.dismiss();
  }

  hasMoney(product){
    if ('purchase' in product){
      if (product.purchase.money > 0) return true
      else return false
    }
    else
      return false
  }

  getPrice(product){

    if (this.hasMoney(product)){
      return product.purchase.points
    }
    else return product.price - product.discount
  }
}
